<template>
  <div class="media-account">
    <a-button type="primary" class="bind-btn" @click="bindAccount">关联账号</a-button>
  	<a-table
      :columns="user.columns"
      :row-key="(record, index) => index"
      :data-source="user.data"
      :pagination="user.pagination"
      size="small"
      :loading="user.loading"
      @change="(pagination) => handleTableChange('user', pagination)"
      :rowSelection="{
        type: 'radio',
        onChange: rowChange
      }"
    >
      <template slot="handle" slot-scope="text, record">
        <a-popconfirm
          title="解除关联后系统中将不会再统计该账号数据，请确认是否解除关联。"
          ok-text="确定"
          cancel-text="取消"
          @confirm="unbindClick(record)"
        >
          <icon-font class="unbind-btn" type="icon-Disconnect"/>
        </a-popconfirm>
      </template>
    </a-table>
    <template v-if="user.nowRow">
      <fb-account ref="fbAccount" :nowRow="user.nowRow" v-if="code === 'FB'"></fb-account>
      <gg-account ref="ggAccount" :nowRow="user.nowRow" v-else-if="code === 'GG'"></gg-account>
    </template>
  </div>
</template>
<script>
import { mediaOAuthBindPath, mediaOAuthUnbind, getGoogleMcc, ggAccountOfMcc, synGoogleMccTime, synGoogleMcc, getGGUsers } from "@/api/mediadata"
import { pageBmOfUser, fbPageAccountOfBm, getBmSynTime, fbSynBM, getFBUsers } from "@/api/mediadata"
import { oePageAccount, getOESynTime, oeSynAccount, getOEUsers } from "@/api/mediadata"
import { ttPageAccount, getTTSynTime, ttSynAccount, getTTUsers } from "@/api/mediadata"
import { ksPageAccount, getKSSynTime, ksSynAccount, getKSUsers } from "@/api/mediadata"
import fbAccount from "./fbAccount"
import ggAccount from "./ggAccount"

const columns = [
	{
		title: '账户ID',
		dataIndex: 'userId',
		width: 250,
		align: 'center',
	},
	{
		title: '账户名称',
		dataIndex: 'name',
		align: 'center',
		width: 215,
	},
	{
		title: '邮箱',
		dataIndex: 'email',
		align: 'center',
		width: 250,
	},
	{
		title: '关联时间',
		dataIndex: 'createTime',
		align: 'center',
		width: 151,
	},
	{
		title: '操作人',
		dataIndex: 'operator',
		align: 'center',
		width: 151,
	},
  {
		title: '操作',
		dataIndex: 'handle',
		align: 'center',
		scopedSlots: { customRender: 'handle' },
		width: 151,
	},
]
export default {
	name: 'MediaData',
	data() {
		return {
      user: {
			  loading: false,
        pagination: {
          current: 1,
          total: 0,
          pageSize: 10
        },
			  data: [],
			  columns,
        nowRow: null,
      },
      classUser: {
			  loading: false,
        pagination: {
          current: 1,
          total: 0,
          pageSize: 10
        },
			  data: [],
			  columns
      },
      synLoading: false,
      synTime: '',
      getUsers: getFBUsers,
      synApi: fbSynBM,
      getUserClass: pageBmOfUser,
      getSynTime: getBmSynTime,
      getAccount: fbPageAccountOfBm,
		}
	},
  props: ['code'],
  methods: {
    // 同步账号
    synClick() {
      this.synLoading = true
      this.synApi({
        userId: this.user.nowRow.userId,
      }).then((res) => {
        this.$message.success('同步成功！')
        this.getClassList()
      }).finally(() => this.synLoading = false)
    },
    // 绑定账号
    bindAccount() {
      mediaOAuthBindPath({
        mediaCode: this.code
      }).then((res) => {
        window.open(res.data)
      }).finally(() => this.loading = false)
    },
    // 解绑账号
    unbindClick(record) {
      mediaOAuthUnbind({
        mediaCode: this.code,
        id: record.id
      }).then((res) => {
        this.$message.success('解绑成功！')
        this.getList()
      })
    },
    rowChange(selectedRowKeys, selectedRows) {
      this.user.nowRow = selectedRows[0] || null
      if(!this.user.nowRow){
        return
      }
      if(this.code === 'FB') {
        this.$nextTick(() => {
          this.$refs.fbAccount.init()
        })
      } else if(this.code === 'GG') {
        this.$nextTick(() => {
          this.$refs.ggAccount.init()
        })
      } else {
        this.getClassList()
        this.handleSynTime()
      }
    },
    handleSynTime() {
      this.getSynTime({
        userId: this.user.nowRow.userId,
      }).then((res) => {
        this.synTime = res
      })
    },
    getClassList(searchKeyWord) {
      this.classUser.loading = true
      this.getUserClass({
        pageSize: this.classUser.pagination.pageSize,
        pageNo: this.classUser.pagination.current,
        userId: this.user.nowRow.userId,
        searchKeyWord
      }).then((res) => {
        console.log(res)
        this.classUser.data = res.data.recordList || []
        this.classUser.pagination.total = res.data.recordCount
      }).finally(() => this.classUser.loading = false)
    },
    search(value) {
      this.classUser.pagination.current = 1
      this.getClassList(value)
    },
    getList(searchKeyWord) {
      this.user.loading = true
      this.getUsers({
        pageSize: this.user.pagination.pageSize,
        pageNo: this.user.pagination.current,
        searchKeyWord
      }).then((res) => {
        this.user.data = res.data.recordList || []
        this.user.pagination.total = res.data.recordCount
      }).finally(() => this.user.loading = false)
    },
    handleTableChange(type, pagination) {
			const pager = { ...this[type].pagination };
			pager.current = pagination.current;
			this[type].pagination = pager;
      if(type === 'user') {
        this.getList()
      } else if(type === 'classUser') {
        this.getClassList()
      } else if(type === 'account') {
        this.getAccountList()
      }
		},
  },
  components: {
    fbAccount,
    ggAccount
  },
  mounted() {
    switch (this.code) {
      case 'GG':
        this.getUsers = getGGUsers
        this.synApi = synGoogleMcc
        this.getUserClass = getGoogleMcc
        this.getAccount = ggAccountOfMcc
        this.getSynTime = synGoogleMccTime
        break;
      case 'OE':
        this.getUsers = getOEUsers
        this.synApi = oeSynAccount
        this.getUserClass = oePageAccount
        this.getAccount = null
        this.getSynTime = getOESynTime
        break;
      case 'TT':
        this.getUsers = getTTUsers
        this.synApi = ttSynAccount
        this.getUserClass = ttPageAccount
        this.getAccount = null
        this.getSynTime = getTTSynTime
        break;
      case 'KS':
        this.getUsers = getKSUsers
        this.synApi = ksSynAccount
        this.getUserClass = ksPageAccount
        this.getAccount = null
        this.getSynTime = getKSSynTime
        break;
      default:
        break;
    }
    this.getList()
  }
}
</script>
<style lang="less">
.media-account {
  position: relative;
  .input-search {
    width: 252px;
  }
  .bind-btn {
    top: -53px;
    position: absolute;
    right: 24px;
  }
  .unbind-btn {
    cursor: pointer;
  }
  .account-title {
    background: #fbfcfe;
    padding: 16px 24px;
    border-bottom: 1px solid #E0E7F7;
    .account-name {
      color: #2D3446;
      font-weight: 500;
      line-height: 32px;
      font-size: 16px;
    }
    .account-time {
      font-size: 12px;
      line-height: 32px;
      color: #9CA9CB;
      margin-left: 12px;
    }
    .syn-log-btn {
      font-size: 12px;
      height: 32px;
      line-height: 32px;
      &:hover {
        color: #4278FF;
      }
    }
    .syn-help {
      color: #9ca9cb;
      line-height: 24px;
    }
  }
  .account-box {
    background: #fbfcfe;
  }
  .syn-mcc-btn {
    height: 24px;
    line-height: 24px;
    color: #2D3446;
    background: #F3F6FE;
    padding: 0 8px;
    margin-left: 16px;
    .anticon {
      color: #A5B2D0;
      width: 14px;
      height: 14px;
      @-webkit-keyframes spin {
        from {
            -webkit-transform: rotate(0deg);
        }
        to {
            -webkit-transform: rotate(360deg);
        }
      }
      @keyframes spin {
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(360deg);
        }
      }
      &.active {
        -webkit-animation: spin 1s linear 1s 5 alternate;
        animation: spin 1s linear infinite;
      }
    }
  }
}
</style>